<script setup lang="ts">
import Logo from '~/components/modules/logo/Logo.vue';
import UiIcon from '~/components/ui/UiIcon/UiIcon.vue';

const emit = defineEmits<{
    finished: [];
}>();

const onArrowCycleEnd = (event: AnimationEvent) => {
    if (!event.animationName.includes('leftPulse')) {
        return;
    }

    emit('finished');
};
</script>

<template>
    <section class="preloader">
        <div class="preloader__content">
            <UiIcon
                name="preloader/arrow"
                class="preloader__arrow preloader__arrow--left"
                @animationiteration="onArrowCycleEnd"
            />

            <Logo class="preloader__logo"/>

            <UiIcon name="preloader/arrow" class="preloader__arrow preloader__arrow--right" />
        </div>
    </section>
</template>

<style scoped lang="scss">
@import 'styles/preloader.scss';
</style>
